
import InputLabel from '@marketplace/components/forms/inputs/shared/input-label.vue'
import TextInput from '@marketplace/components/forms/inputs/text-input.vue'
import TextareaInput from '@marketplace/components/forms/inputs/textarea-input.vue'
import { REQUEST_ACCESS_APPROVAL } from '@marketplace/graphql/storefront.js'
import { getFirstUserError } from '@marketplace/helpers/data.js'
import { trackClick } from '@marketplace/helpers/segment/index.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

const checkForDot = (value) => {
    return value.match(/\./g) || false
}

export default {
    name: 'ModalRequestAccess',

    components: {
        TextInput,
        InputLabel,
        TextareaInput,
    },

    props: {
        storefrontId: {
            type: [String, Number],
            required: true,
        },
        brandName: {
            type: String,
            default: '',
        },
        trackingCategory: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            isSubmitting: false,
            isConfirmed: false,

            form: {
                url: '',
                instagramUsername: '',
                brandConcept: '',
            },
        }
    },

    computed: {
        ...mapGetters('global', ['account', 'companyAddress']),
    },

    created() {
        this.form.url = this.account.url
        this.form.instagramUsername = this.account.instagramUsername
    },

    validations() {
        return {
            form: {
                url: { required, checkForDot },
                instagramUsername: { required },
                brandConcept: { required },
            },
        }
    },

    methods: {
        checkIfValid() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                return
            }

            this.isSubmitting = true

            this.$apollo
                .mutate({
                    mutation: REQUEST_ACCESS_APPROVAL,
                    variables: {
                        storefrontId: this.storefrontId,
                        url: this.form.url,
                        instagramUsername: this.form.instagramUsername,
                        brandConcept: this.form.brandConcept,
                    },
                })
                .then(({ data }) => {
                    if (!data.retailerRequestApproval?.success) {
                        const userErrorMessage = getFirstUserError(
                            data.retailerRequestApproval
                        )
                        EventBus.$emit('userErrorMessage', userErrorMessage)

                        return
                    }

                    EventBus.$emit('hasAccessRequested', true)

                    trackClick('Supplier Approval Request Sent', {
                        category: this.trackingCategory,
                    })

                    this.confirmed = true

                    setTimeout(() => {
                        this.$vfm.hideAll()
                    }, 1000)
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        },
    },
}
